import { useEffect, useState } from 'react';

// Charge les dimensions naturelles de l'image de fond du plan.
export const useImageDims = (url) => {
  const [dims, setDims] = useState(null);
  useEffect(() => {
    if (!url) { setDims(null); return undefined; }
    let alive = true;
    const img = new Image();
    img.crossOrigin = 'use-credentials';
    img.onload = () => {
      if (alive) setDims({ w: img.naturalWidth || 1000, h: img.naturalHeight || 1000 });
    };
    img.src = url;
    return () => { alive = false; };
  }, [url]);
  return dims;
};
